import EnumService from '../EnumService'

export default class OportunidadeStatusService extends EnumService{

    constructor(){
        super('enumStatusOportunidade');
    }
  
  }